<mat-toolbar color="primary">
  <span>Weight Change Categories</span>
</mat-toolbar>

<div class="page-content">
  <!-- Project selector -->
  <mat-card class="selector-card" appearance="outlined">
    <div class="selectors-row">
      <mat-form-field appearance="outline">
        <mat-label>Project</mat-label>
        <mat-select [(ngModel)]="selectedProjectId" (ngModelChange)="onProjectChange($event)">
          @for (project of projects; track project.id) {
            <mat-option [value]="project.id">{{ project.name }} ({{ project.id }})</mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (selectedProjectId) {
        <div class="copy-row">
          <mat-form-field appearance="outline">
            <mat-label>Copy from project</mat-label>
            <mat-select [(ngModel)]="copyFromProjectId">
              @for (project of projects; track project.id) {
                @if (project.id !== selectedProjectId) {
                  <mat-option [value]="project.id">{{ project.name }} ({{ project.id }})</mat-option>
                }
              }
            </mat-select>
          </mat-form-field>
          <button mat-flat-button color="accent" [disabled]="!copyFromProjectId" (click)="copyFromProject()">
            <mat-icon>content_copy</mat-icon>
            Copy
          </button>
        </div>
      }
    </div>
  </mat-card>

  @if (selectedProjectId) {
    <mat-card class="categories-card" appearance="outlined">
      <div class="categories-header">
        <h3>Categories</h3>
        <button mat-flat-button color="primary" (click)="startAdd()" [disabled]="addingNew">
          <mat-icon>add</mat-icon>
          Add
        </button>
      </div>

      @if (loading) {
        <mat-progress-spinner mode="indeterminate" diameter="32"></mat-progress-spinner>
      } @else {
        <table mat-table [dataSource]="categories" class="categories-table">
          <!-- Sort order -->
          <ng-container matColumnDef="sortOrder">
            <th mat-header-cell *matHeaderCellDef>Order</th>
            <td mat-cell *matCellDef="let cat">
              @if (editingId === cat.id) {
                <input matInput type="number" [(ngModel)]="editSortOrder" class="edit-input order-input" />
              } @else {
                {{ cat.sortOrder }}
              }
            </td>
          </ng-container>

          <!-- Label -->
          <ng-container matColumnDef="label">
            <th mat-header-cell *matHeaderCellDef>Label</th>
            <td mat-cell *matCellDef="let cat">
              @if (editingId === cat.id) {
                <input matInput [(ngModel)]="editLabel" class="edit-input label-input" />
              } @else {
                {{ cat.label }}
              }
            </td>
          </ng-container>

          <!-- Actions -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let cat" class="actions-cell">
              @if (editingId === cat.id) {
                <button mat-icon-button color="primary" title="Save" (click)="confirmEdit(cat)">
                  <mat-icon>check</mat-icon>
                </button>
                <button mat-icon-button title="Cancel" (click)="cancelEdit()">
                  <mat-icon>close</mat-icon>
                </button>
              } @else {
                <button mat-icon-button title="Edit" (click)="startEdit(cat)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" title="Delete" (click)="deleteCategory(cat)">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="['sortOrder', 'label', 'actions']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['sortOrder', 'label', 'actions']"></tr>
        </table>

        @if (categories.length === 0) {
          <p class="empty">No categories yet. Add one above or copy from another project.</p>
        }

        <!-- Inline add row -->
        @if (addingNew) {
          <div class="add-row">
            <input
              matInput
              placeholder="Category label"
              [(ngModel)]="newLabel"
              class="edit-input label-input"
              (keyup.enter)="confirmAdd()"
            />
            <button mat-icon-button color="primary" title="Save" (click)="confirmAdd()" [disabled]="!newLabel.trim()">
              <mat-icon>check</mat-icon>
            </button>
            <button mat-icon-button title="Cancel" (click)="cancelAdd()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        }
      }
    </mat-card>
  }
</div>
